module.exports = __webpack_public_path__ + "media/site_templates/www.tilingquotes.com.au/images/our_services_3-2ac61ca54686b4dd4fcf6559e2255802.jpg";